/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInventoryAdjustment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m12 1.82 9 5.626V10.5h-2v-.696l-6 3.75v5.642l.47-.294 1.06 1.696L12 22.179l-9-5.625V7.446zm-1 17.376v-5.642l-6-3.75v5.642zM5.887 8 12 11.82 18.113 8 12 4.18zM19 11.698l3.64 3.034-1.28 1.536L19 14.302l-2.36 1.966-1.28-1.536zm0 8-2.36-1.966-1.28 1.536L19 22.302l3.64-3.034-1.28-1.536z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInventoryAdjustment as InventoryAdjustment };
